import NetworkService from '../services/network.service'

class EmailApi {
    getEmailLookUp = async () => {
        let url = `api/emaillookup`;
        let config = {}
        let data = await NetworkService.get(url, config)
        return data && data.data
        ? data.data : data
    };
    putEmail = async (companyId: any, data: any) => {
        let url = `api/emaillookup`;
        Object.entries(data).forEach((module: any) => {
            module[1]['companyId'] = Number(companyId);
        })

        let response = await NetworkService.put(url, data);
        return response && response.data
            ? response.data : response
    }
}
export default EmailApi;